import axios from 'src/api/Api';
import { GET_LINKS_SUCCESS, GET_LINKS_FAILURE } from '../actions';
import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export function* getLinks(action) {
    const url = `occ/v2/${localStorage.getItem('baseSiteId')}/calendar/getLinks`;

    try {
        const result = yield axios({
            method: 'get',
            url: url,
            //  url: `occ/v2/${localStorage.getItem('baseSiteId')}/accounts/list?isFavorite=false&pageLimit=25&pageNum=${page}&searchCityParam=${city}&searchStateParam=${state}&searchAccountParam=${accountNameOrNumber}&sortOrder=ASC&sortParam=ACCOUNTNAME`,
        }).then((response) => response.data);
        yield put({
            type: GET_LINKS_SUCCESS,
            payload: result,
        });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_LINKS_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
